import { Injectable } from '@angular/core';
import { selectAccount } from '@app/common/store';
import {
  PaymentsApiService,
  SubscriptionApiService,
} from '@app/subscription/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { selectCurrentUserId } from 'pl-core-services';
import {
  switchMap,
  map,
  catchError,
  of,
  mergeMap,
  retry,
  timer,
  throwError,
} from 'rxjs';
import * as actions from '../current/current.actions';

@Injectable()
export class CheckoutSuccessEffects {
  refetchCurrentSubscription$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.checkoutSucceeded),
      switchMap(({ session_id }) =>
        this.refreshCurrentLicense(session_id).pipe(
          map((subscription) =>
            actions.loadCurrentSubscriptionSuccess({
              subscription,
            })
          ),
          catchError((error) => of(actions.checkoutSessionError({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store,
    private subscriptionService: SubscriptionApiService,
    private paymentsService: PaymentsApiService
  ) {}

  private refreshCurrentLicense(session_id: string) {
    return this.paymentsService.getCheckoutSession(session_id).pipe(
      concatLatestFrom(() => [
        this.store.select(selectAccount),
        this.store.select(selectCurrentUserId),
      ]),
      mergeMap(([session, account, userId]) =>
        this.loadCurrentSubbscriptionUntilSynced(
          session.license_name,
          account.uuid,
          userId
        ).pipe(
          retry({
            delay: (error) => {
              if (error === 'Checkout session is not complete') {
                return timer(3000);
              }
              return throwError(() => error);
            },
          })
        )
      )
    );
  }

  private loadCurrentSubbscriptionUntilSynced(
    expectedLicense: string,
    accountId: string,
    userId: string
  ) {
    return this.subscriptionService.getSubscription(accountId, userId).pipe(
      mergeMap((subscription) => {
        if (subscription.license !== expectedLicense) {
          return throwError(() => 'Checkout session is not complete');
        }
        return of(subscription);
      })
    );
  }
}
